import { useTonConnectContext } from '../contexts/TonConnectContext';

export const useTonConnect = () => {
  return useTonConnectContext();
};

export default useTonConnect;

